import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Wind, RefreshCw } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: <Activity className="w-10 h-10" data-id="element-211" />,
    step: '01',
    title: 'Stimulate',
    subtitle: 'Awaken Healthy Circulation',
    description: 'Warming herbs like ginger and cayenne gently stimulate blood flow, preparing your body to move stagnant fluid and waste. This is the spark that starts your lymphatic reset.'
  }, {
    icon: <Wind className="w-10 h-10" data-id="element-212" />,
    step: '02',
    title: 'Mobilize',
    subtitle: 'Encourage Inner Clarity',
    description: 'Supportive botanicals help your lymphatic system mobilize trapped fluid and cellular waste, clearing the pathways so your body can function at its best.'
  }, {
    icon: <RefreshCw className="w-10 h-10" data-id="element-213" />,
    step: '03',
    title: 'Drain & Balance',
    subtitle: 'Release & Renew',
    description: 'Natural diuretic herbs promote gentle drainage, helping you feel flatter, lighter, and more balanced. This is where you see and feel the transformation.'
  }];
  return <section className="py-24 bg-gradient-to-br from-[#1B5E20] to-[#14532D] text-white overflow-hidden relative" data-id="element-214">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-215">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-216" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <span className="text-[#10B981] font-bold tracking-wider uppercase text-sm" data-id="element-219">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2" data-id="element-220">
            The LymphoriaX Mechanism
          </h2>
          <p className="text-gray-300 mt-4 max-w-2xl mx-auto" data-id="element-221">
            Our 3-step formula works with your body's natural systems to restore
            balance
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-222">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-[#10B981]/30" data-id="element-223" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10" data-id="element-224">
              <div className="bg-[#10B981] w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8 border-4 border-[#1B5E20] shadow-2xl" data-id="element-225">
                {step.icon}
              </div>

              <div className="text-center px-4" data-id="element-226">
                <div className="text-[#10B981] font-bold text-lg mb-2" data-id="element-227">
                  {step.title}
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-228">{step.subtitle}</h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-229">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}